module.exports = __webpack_public_path__ + "img/BLUE B.6b201b7a.jpg";